import React from "react";
import { Divider } from "../../../BP2Components";
import "./SectionField.less";
import PropTypes from "prop-types";
import { handleGridTechname } from "../../GeneralScripts";

const SectionField = ({ element, isVisible }) => {
   const translatedLabel = element.label;
   return (
      <div
         key={element.tech_name}
         className={element.label === "" ? "section-field--hidden" : "section-field--visible"}
         style={{
            display: isVisible(element) ? "" : "none",
            gridArea: handleGridTechname(element.tech_name)
         }}
      >
         <p className="p1 section-field--visible__title">{translatedLabel}</p>
         <Divider className="section-field--visible__divider" />
      </div>
   );
};

SectionField.propTypes = {
   element: PropTypes.object.isRequired,
   isVisible: PropTypes.func
};
export default SectionField;
